import { render, staticRenderFns } from "./TelemetryTireTemperatureSection.vue?vue&type=template&id=5267ad23&scoped=true"
import script from "./TelemetryTireTemperatureSection.vue?vue&type=script&lang=ts"
export * from "./TelemetryTireTemperatureSection.vue?vue&type=script&lang=ts"
import style0 from "./TelemetryTireTemperatureSection.vue?vue&type=style&index=0&id=5267ad23&prod&lang=scss&scoped=true"
import style1 from "./TelemetryTireTemperatureSection.vue?vue&type=style&index=1&id=5267ad23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5267ad23",
  null
  
)

export default component.exports